export default {
  pageTitle: 'Sertifikasi',
  metaDescription: 'TEF memiliki sertifikasi ASME U dan R Stamp, National Board, ISO 9001:2015, MIGAS, dan EBTKE, memastikan hasil fabrikasi sesuai standar kualitas internasional.',
  hero: { title: 'Sertifikasi' },
  certSection: {
    heading: 'Sertifikasi dan Standar',
    intro: 'Kami telah memperoleh sertifikasi mutu berikut:',
    otherCodesIntro: 'Selain itu, kami juga dapat memenuhi Kode Bejana Tekan (Pressure Vessel Codes) lainnya, seperti :',
    otherCodes: {
      japanese: 'Kode Jepang',
    },
  },
};
